import { makeEnvironmentProviders, type EnvironmentProviders, type Provider } from '@angular/core';
import {
  GRPC_INTERCEPTORS,
  GRPC_LOGGER_SETTINGS,
  type GrpcLoggerChildOptions,
  type GrpcLoggerRootOptions,
} from '@ngx-grpc/core';
import { GrpcLoggerInterceptor } from './grpc-logger-interceptor';

function buildGrpcLoggerProviders(
  options?: GrpcLoggerRootOptions | GrpcLoggerChildOptions,
): Provider[] {
  const providers: Provider[] = [
    { provide: GRPC_INTERCEPTORS, useClass: GrpcLoggerInterceptor, multi: true },
  ];

  if (options?.settings) {
    providers.push({ provide: GRPC_LOGGER_SETTINGS, useValue: options.settings });
  }

  return providers;
}

export function provideGrpcLogger(options?: GrpcLoggerRootOptions): EnvironmentProviders {
  return makeEnvironmentProviders(buildGrpcLoggerProviders(options));
}

export function provideGrpcLoggerChild(options?: GrpcLoggerChildOptions): EnvironmentProviders {
  return makeEnvironmentProviders(buildGrpcLoggerProviders(options));
}
